import React from 'react';
import PropTypes from "prop-types";
import Profile from './Profile';
import {Button, Components, InputInformation, InputList, ValidationEngine, validationEngineFromInputInformationList, ValidationRules, ValidationStyle, ValidationType} from 'dts-react-common';
import Inputmask from 'inputmask';
import {connect} from 'react-redux';
import webservice from '../app/Webservice';
import {disableUI, dispatchUpdateData, PAGES, showMessage} from '../common/Shared';
import {Link} from 'react-router-dom';
import NoOfferFound from "../common/NoOfferFound";

const propTypes = {
	accepted: PropTypes.bool.isRequired,
	offer: PropTypes.object,
};

const defaultProps = {
	offer: undefined,
};

const mapStateToProps = (state) => {
	return {
		accepted: state.app.accepted,
		offer: state.app.offer,
	};
};

const routingMask = {
    inputMask: new Inputmask('999999999', {
        placeholder: '',
        clearMaskOnLostFocus: false,
    }),
};

const bankingMask = {
    inputMask: new Inputmask('9{6,20}', {
        placeholder: '',
        clearMaskOnLostFocus: false,
    }),
};


class DirectDeposit extends React.Component {
    constructor(props) {
        super(props);

		this.inputs = [
            new InputInformation({
                field: 'directDepositRoutingNumber',
                label: "Bank ABA Routing Number",
                type: Components.TEXT_INPUT,
                className: "stack-form",
                maskType: routingMask,
                validationTypes: [
                    ValidationRules[ValidationType.CUSTOM_CALLBACK](listData => listData.match(/^\d{9}$/), () => 'Routing number must be 9 numeric digits.'),
                ],
                size: 'size-large'}),
            new InputInformation({
                field: 'directDepositAccountNumber',
                label: "Bank Account Number",
                type: Components.TEXT_INPUT,
                className: "stack-form",
                maskType: bankingMask,
                validationTypes: [
                    ValidationRules[ValidationType.CUSTOM_CALLBACK](listData => listData.match(/^\d{6,20}$/), () => 'Account number must be 6 - 20 numeric digits.'),
                ],
                size: 'size-large'}),
            new InputInformation({
                field: 'directDepositAccountType',
                label: "Banking Type",
                type: Components.SEGMENTED_BUTTON,
                options: [
                	{ value: 'C', label: 'Checking' },
					{ value: 'S', label: 'Savings' }
				], className: "stack-form"
            }),
        ];

        this.inputs.forEach(input => {
            input.onChange = (field, value) => dispatchUpdateData({path: 'app.offer', field: field, value: value});
        });

        if(this.props.offer && !this.props.offer.directDepositAccountType) {
        	// Make sure we have a value to render
            this.props.offer.directDepositAccountType = 'checking';
            dispatchUpdateData({path: 'app.offer', field: 'directDepositAccountType', value: 'checking'});
        }

        this.validationEngine = validationEngineFromInputInformationList(this.inputs);
        this.validationEngine.setValidationStyle(ValidationStyle.ALWAYS);

        this.saveRecord = this.saveRecord.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

	saveRecord() {
        if (this.validationEngine.isValid(this.props.offer)) {
            webservice.offer.save(this.props.offer).then(showMessage('Saved', 'Your account details have been successfully saved.'));
        } else {
            showMessage('Invalid Input', 'Enter valid direct deposit bank routing and account numbers before saving.')
        }
	}

    render() {
        this.inputs.map(input => input.disabled = disableUI());
        const listData = Object.assign({}, this.props.offer);
        listData.directDepositAccountType = listData.directDepositAccountType || '';
        this.validationEngine.isValid(this.props.offer);

        return (
            <React.Fragment>
                {this.props.offer && this.props.offer.guid ?
				<div>
					<Profile/>
					<section>
						<h2 className="headline">Direct Deposit</h2>
						<div className="content">
							<p><strong>Direct Deposit Information</strong></p>
							<p>State employees are paid biweekly. You may have your paycheck electronically deposited in a designated
								bank/credit union/investment firm account.
								At this time you are setting up your main account. If you choose to skip this step, you will receive a
								reminder email to set up your direct deposit account.
								If you do not set up a direct deposit account you will receive a paper paycheck.</p>
						</div>
					</section>
					<section className="mb-spacing">
						<h2 className="headline">Enter Direct Deposit Details</h2>
						<div className="content">
							<p>Please call your financial institution to verify your routing and account numbers.</p>
                            <div className="flex flex-wrap mb-spacing" id="depositDetails">
                                <InputList inputs={this.inputs} data={listData} validationEngine={this.validationEngine} />
                                <img src="/img/blank-check.png" className="align-self-center max-100"/>
                            </div>
							<div className="flex">
                                <Button
									label="Save"
									onClick={this.saveRecord}
									className="button mr-spacing"
                                    disabled={this.props.accepted}
								/>
								<Link to={`/${PAGES.OFFER_ACCEPTANCE}/${this.props.offer.guid}`} className="button continue-button">
									Continue to Offer Acceptance
								</Link>
							</div>
						</div>
					</section>
				</div> : <NoOfferFound/> }
			</React.Fragment>
		);
	}
}

DirectDeposit.propTypes = propTypes;
DirectDeposit.defaultProps = defaultProps;

export default connect(mapStateToProps)(DirectDeposit);